var map = {
	"./frontend/AndroidGuide.vue": 81944,
	"./frontend/Banking.vue": 91827,
	"./frontend/BetslipHistory.vue": 20491,
	"./frontend/BodyFB.vue": 78078,
	"./frontend/Commission.vue": 90567,
	"./frontend/ContactUs.vue": 35571,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 36489,
	"./frontend/History.vue": 96057,
	"./frontend/Home.vue": 71707,
	"./frontend/IOSGuide.vue": 46562,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 74099,
	"./frontend/Index.vue": 87045,
	"./frontend/Live.vue": 34135,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 43595,
	"./frontend/MaungFB.vue": 57626,
	"./frontend/PrivacyPolicy.vue": 99023,
	"./frontend/Promotion.vue": 59066,
	"./frontend/Setting.vue": 59293,
	"./frontend/VideoLink.vue": 96211,
	"./frontend/VipLevels.vue": 46570,
	"./frontend/Withdraw.vue": 60854,
	"./frontend/auth/Login.vue": 11104,
	"./frontend/auth/Register.vue": 55411,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 99823,
	"./frontend/auth/VerifyNotAuth.vue": 2395,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 92687,
	"./frontend/components/FBPreviewVoucher.vue": 79244,
	"./frontend/components/FBVoucher.vue": 9650,
	"./frontend/components/FootballTeamCard.vue": 19813,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/InputSelectDrawModal.vue": 90313,
	"./frontend/components/LuckyWheel.vue": 30187,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 47750,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 66459,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/UserDepositTable.vue": 65204,
	"./frontend/components/UserTransactions.vue": 88126,
	"./frontend/components/UserWithdrawTable.vue": 95717,
	"./frontend/components/Voucher.vue": 49780,
	"./frontend/normal-user/2d/2d.vue": 74306,
	"./frontend/normal-user/2d/ClosedDays.vue": 96899,
	"./frontend/normal-user/2d/Home.vue": 90292,
	"./frontend/normal-user/2d/Winner.vue": 70630,
	"./frontend/normal-user/3d/3d.vue": 3096,
	"./frontend/normal-user/3d/Home.vue": 26470,
	"./frontend/normal-user/DreamBooks.vue": 46314,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Arcade.vue": 75950,
	"./frontend/normal-user/game/Fishing.vue": 87936,
	"./frontend/normal-user/game/Game.vue": 91217,
	"./frontend/normal-user/game/Slot.vue": 27642,
	"./frontend/normal-user/shankomee/Room.vue": 23084,
	"./frontend/promotions/Promotions.vue": 66961,
	"./frontend/promotions/components/NoPromotions.vue": 89503,
	"./frontend/promotions/components/PromotionCard.vue": 78032,
	"./frontend/user/components/PromotionCard.vue": 61113,
	"./frontend/user/promotions/Index.vue": 38538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;